module.exports = __webpack_public_path__ + "static/risingStar-65403bce981e61154f070b349b48dc41.jpg";